import NeighbourHoodIntrestCard from "./NeighbourHoodIntrestCard";

export default NeighbourHoodIntrestCard;
